<!-- =========================================================================================
    File Name: TodoAddNew.vue
    Description: Add new todo component
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="todo__filters-container">

        <!-- all -->
        <div class="px-6 py-4">
            <div tag="span" @click="doFilter('all')" class="flex cursor-pointer" :class="{'text-primary': currentFilter == 'all'}" >
                <feather-icon icon="LayersIcon" :svgClasses="[{'text-primary stroke-current': currentFilter == 'all'}, 'h-6 w-6']"></feather-icon>
                <span class="text-lg ml-3">{{ $t('KPU.Filters.All') }} </span>
            </div>
           
        </div>

        <vs-divider v-if="displayFilters"></vs-divider>

        <!-- starred -->
        <div v-if="displayFilters" class="px-6 py-4">
          <h5>Filters</h5>
          <template v-for="filter in todoFilters">
            <div tag="span" @click="doFilter(filter.filter)"  class="flex mt-6 cursor-pointer" :class="{'text-primary': currentFilter == filter.filter}" :key="filter.filter" >
                <feather-icon :icon="filter.icon" :svgClasses="[{'text-primary stroke-current': currentFilter == filter.filter}, 'h-6 w-6']"></feather-icon>
                <span class="text-lg ml-3">{{ $t('KPU.Filters.' + filter.filterName) }}</span>
            </div>
          </template>
        </div>

        <vs-divider v-if="displayStatus"></vs-divider>

        <div v-if="displayStatus" class="px-6 py-4">
            <h5>Status</h5>
            <div class="todo__lables-list">
               <div tag="span" @click="doFilter(tag.value)"  class="todo__label flex items-center mt-6 cursor-pointer" v-for="(tag, index) in taskTags" :key="index" >
                  <div class="ml-1 h-3 w-3 rounded-full mr-4" :class="'border-2 border-solid border-' + tag.color" />
                  <span class="text-lg" :class="{'text-primary': currentFilter == tag.value}">{{ $t('KPU.KPUStatus.' +  tag.value) }}</span>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

import KPUStatusEnum from './../KPUStatusEnum.js'

export default {
  props: {
    displayStatus : {
      type: Boolean,
      default: true
    },
    displayFilters : {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      currentFilter: 'all',
      todoFilters: [
        { filterName: 'Completed', filter: 'completed', icon: 'CheckIcon' },
        { filterName: 'Trashed', filter: 'trashed', icon: 'TrashIcon' }
      ],
      tags: [
        {
          id: KPUStatusEnum.Ok,
          value : KPUStatusEnum.Ok,
          color: 'success'
        },
        {
          id: KPUStatusEnum.Warning,
          value : KPUStatusEnum.Warning,
          color: 'warning'
        },
        {
          id: KPUStatusEnum.BehindTarget,
          value : KPUStatusEnum.BehindTarget,
          color: 'danger'
        }
      ]
    }
  },
  computed: {
    taskTags () {
      return this.tags
    },
    todoFilter () {
      return this.$route.params.filter
    },
    baseUrl () {
      const path = this.$route.path
      return path.slice(0, path.lastIndexOf('/'))
    }
  },
  methods: {
    doFilter (filter) {
      this.currentFilter = filter;
      this.$emit("filterChange", filter);
    }
  }
}
</script>
